import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-integration-report',
  templateUrl: './integration-report.component.html',
  styleUrls: ['./integration-report.component.scss']
})
export class IntegrationReportComponent {

  public data:any = {}
  public logs:any = [];
  public dates:any = [];
  public is_loading_game:boolean = false;
  public is_loading_logs:boolean = false;
  public today:any = new Date()

  constructor(private http: HttpService, private router: Router) {
    this.generateDates();
    this.today.setDate(this.today.getDate() + 1);
    this.today = this.today.toISOString().split('T')[0];
  }

  // Click a game row -> drill into per-player winloss for that game over the SAME
  // filtered date range. Dates + game identity ride in the query string so the
  // detail page is refresh-safe; the game_title also rides in navigation state
  // for a nicer header without a re-lookup.
  openGameDetail(log:any) {
    const company_uuid = this.http.getStaticSelectedCompany();
    this.router.navigate(['/lo', company_uuid, 'agent-report', 'player-detail'], {
      queryParams: {
        game_id: log.game_id,
        platform: log.platform || '',
        platform_type: log.platform_type || '',
        from: this.data.from,
        to: this.data.to,
      },
      state: { game_title: log.game_title, platform: log.platform, platform_type: log.platform_type },
    });
  }

  async filter() {

    // data.from / data.to are bound to native <input type="date"> (YYYY-MM-DD strings)
    this.is_loading_logs = true;
    let rtn:any = await this.http.post("/admin/seemless-game/agent-log", this.data)

    if(rtn.status){
      this.logs = rtn.logs;
    }
    this.is_loading_logs = false;
  }

  async generateDates() {
    let seven_days_ago = new Date();
    seven_days_ago.setDate(seven_days_ago.getDate() - 7);
    this.data.from = seven_days_ago.toISOString().split('T')[0];
    this.data.to = new Date().toISOString().split('T')[0];
    this.filter();
  // Generate week ranges from last week to 12 weeks ago (total 13 weeks), with week number for the year
  // this.dates = [];

  // // Get last week's Sunday (start of last week)
  // let today = new Date();
  // let day = today.getDay();
  // let lastSunday = new Date(today);
  // lastSunday.setDate(today.getDate() - day - 7); // Go to last week's Sunday

  // for (let i = 0; i < 13; i++) {
  //   let weekStart = new Date(lastSunday);
  //   weekStart.setDate(lastSunday.getDate() - (i * 7));
  //   let weekEnd = new Date(weekStart);
  //   weekEnd.setDate(weekStart.getDate() + 6);

  //   // Get week number for the year (ISO week, but starting Sunday)
  //   let firstJan = new Date(weekStart.getFullYear(), 0, 1);
  //   let days = Math.floor((weekStart.getTime() - firstJan.getTime()) / (24 * 60 * 60 * 1000));
  //   let weekNumber = Math.floor((days + firstJan.getDay()) / 7) + 1;
  //   // Adjust weekStart to Monday and weekEnd to Sunday
  //   // weekStart is currently Sunday, so move to Monday
  //   let monday = new Date(weekStart);
  //   monday.setDate(weekStart.getDate() + 1);
  //   let sunday = new Date(monday);
  //   sunday.setDate(monday.getDate() + 6);

  //   // Format dates as YYYY-MM-DD
  //   let from = ("0" + monday.getDate()).slice(-2) + "-" +
  //              ("0" + (monday.getMonth() + 1)).slice(-2) + "-" +
  //              monday.getFullYear();
  //   let to = ("0" + sunday.getDate()).slice(-2) + "-" +
  //            ("0" + (sunday.getMonth() + 1)).slice(-2) + "-" +
  //            sunday.getFullYear();

  //   this.dates.push({
  //     year: weekStart.getFullYear(),
  //     week_number: weekNumber,
  //     value: weekNumber + "-" + weekStart.getFullYear(),
  //     label: "Week " + weekNumber + ": " + from + " to " + to,
  //     from: from,
  //     to: to
  //   });
//   }

//   // Sort so most recent week is first
// //  this.dates.sort((a, b) => (a.from < b.from ? 1 : -1));
//   this.data.week_number = [this.dates[0].value];
//   this.filter();
  }

  findWeekNumber() {
    let str = [];
    this.data.week_number.forEach(week => {
      let match = this.dates.find(date => date.value === week);
      if(match){
        str.push(match.label);
      }
    });
    return str.join(", ");
  }

  sum(key: string) {
    return this.logs.reduce((acc:any, log:any) => acc + parseFloat(log[key] ?? 0), 0);
  }

}
